var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { connect } from 'react-redux';
import findInObject from '@wikom/find-in-object';
import PropTypes from 'prop-types';
import { showNavbarDropdown, hideNavbarDropdown } from '../actions/navbarActions';
var NavbarDropdown = /** @class */ (function (_super) {
    __extends(NavbarDropdown, _super);
    function NavbarDropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavbarDropdown.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            document.addEventListener('click', this.props.hide);
        }
        else if (!this.props.isOpen && prevProps.isOpen) {
            document.removeEventListener('click', this.props.hide);
        }
    };
    NavbarDropdown.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.props.hide);
    };
    NavbarDropdown.prototype.render = function () {
        var _a = this.props, name = _a.name, children = _a.children, label = _a.label, show = _a.show, hide = _a.hide, isOpen = _a.isOpen;
        return (React.createElement("li", { className: 'dropdown' + (isOpen === true ? ' open' : '') },
            React.createElement("button", { className: "dropdown-toggle", onClick: isOpen === true ? function () { return hide(); } : function () { return show(name); } },
                label,
                " ",
                React.createElement("span", { className: "caret" })),
            React.createElement("ul", { className: "dropdown-menu" }, children)));
    };
    return NavbarDropdown;
}(Component));
NavbarDropdown.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
};
var mapStateToProps = function (_a, _b) {
    var navbar = _a.navbar;
    var name = _b.name;
    return ({
        isOpen: name === findInObject('openDropdown', navbar)
    });
};
var mapDispatchToProps = function (dispatch) { return ({
    show: function (name) { return dispatch(showNavbarDropdown(name)); },
    hide: function () { return dispatch(hideNavbarDropdown()); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(NavbarDropdown);
